module.exports = __webpack_public_path__ + "static/media/BM_Home.4f27497a.svg";